import React, {createContext, useContext} from 'react';
import {
    Preview3DComponentProps,
    PreviewFormValues,
} from 'components/customer/Preview3D/types';
import {ProductDataStore} from 'components/customer/Preview3D/usePreview3DData';
import {Preview3dComponentWithProvider} from 'components/customer/Preview3D/components/Preview3dComponentWithProvider';
import {useNotificationContext} from 'contexts';
import {useErrorHandler} from 'components/customer/Preview3D/hooks/useErrorHandler';

interface Preview3DContextProps {
    values?: PreviewFormValues;
    productDataStore?: ProductDataStore;
    isMiniBrowser?: boolean;
    adjustableLegsQuantity?: number;
}

const Preview3DContext = createContext<Preview3DContextProps>({});

export const use3DContext = () => useContext(Preview3DContext);

export const Preview3DComponent = ({
    product,
    productDataStore,
    isMiniBrowser,
    adjustableLegsQuantity,
    ...props
}: Preview3DComponentProps<ProductDataStore>) => {
    const {messages} = useNotificationContext();

    const hasValidationErrors = Boolean(
        messages.errors && (messages.errors as {fields: string[]}[])?.length
    );
    const {providedValues} = useErrorHandler({product, hasValidationErrors});

    return (
        <Preview3DContext.Provider
            value={{
                values: providedValues,
                productDataStore,
                isMiniBrowser,
                adjustableLegsQuantity,
            }}>
            <Preview3dComponentWithProvider {...props} />
        </Preview3DContext.Provider>
    );
};

export default Preview3DComponent;
